import { ReactNode } from 'react';
import { ConfigProvider } from 'antd';

export default function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#bae34d',
          colorInfo: '#bae34d',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}


